import { Navigate, createFileRoute } from "@tanstack/react-router"
import { BriefsPage } from "@/brief"
import { Feature, FeatureGate } from "@/feature"

export const Route = createFileRoute("/(user)/t/$tenantSlug/briefs")({
  validateSearch: (search): { includeArchived?: boolean } => ({
    // Only present in the URL when on, so the default stays clean
    includeArchived: search.includeArchived === true ? true : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantSlug } = Route.useParams()
  const { includeArchived } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <FeatureGate
      feature={Feature.Briefs}
      otherwise={
        <Navigate
          to="/t/$tenantSlug/dashboard"
          params={{ tenantSlug }}
          replace
        />
      }
    >
      <BriefsPage
        includeArchived={includeArchived ?? false}
        onIncludeArchivedChange={(value) => {
          void navigate({
            search: (prev) => ({
              ...prev,
              includeArchived: value || undefined,
            }),
          })
        }}
      />
    </FeatureGate>
  )
}
